import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';
import GlobalFonts from '../../fonts/fonts';
import { modalActions } from '../../redux/root-action';
import { modals } from '../../utils/constants';
import { formatAmountWithoutDecimals } from '../../utils/helpers';
import { getIncomeGoal } from 'selectors';
import { keyDown } from '../../utils/helpers';

const StyledDesktopContainer = styled.div`
  color: white;
  @media only screen and (max-width: 1023px) {
    display: none;
  }
`;
const StyledMobileContainer = styled.div`
  color: ${tokens.ColorWhite000};
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 8px 0px;
  @media only screen and (min-width: 769px) {
    padding: 32px 0px 32px 0px;
  }
  @media only screen and (min-width: 1024px) {
    display: none;
  }
`;

const SavingsRunOutText = styled.div`
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: normal;
  color: ${tokens.ColorWhite000};
  padding: 8px 0px 8px 0px;
  @media only screen and (min-width: 768px) {
    display: flex;
  }
`;

const SavingsRunOutAge = styled.div`
  font-size: 32px;
  line-height: 1.19;
  letter-spacing: -0.75px;
  color: ${tokens.ColorWhite000};
  display: flex;
  align-items: center;
  font-family: Nimbus Sans Bold;
  @media only screen and (max-width: 768px) {
    font-size: 24px;
    font-family: Nimbus Sans Bold;
  }
`;

const SavingsRunOutImage = styled.img`
  margin: 0px 8px -2px 8px;
  @media only screen and (max-width: 1024px) {
    margin: 0px 16px -2px 8px;
  }
`;

class SavingsRunOut extends Component<any> {
  props: any;

  showSavingsRunOutModal = () => {
    const { showModal } = this.props;
    showModal(modals.SAVINGS_RUN_OUT);
  };

  getSavingsAge = () => {
    const {
      simulationCurrentWant: { runoutAge, participantAge },
    } = this.props;
    if (!participantAge || !participantAge.length) {
      return null;
    }
    if (runoutAge > 0) {
      return runoutAge + participantAge[0];
    } else {
      return participantAge[participantAge.length - 1];
    }
  };

  areSavingsRunningOut = () => {
    const {
      simulationCurrentWant: { runoutAge },
    } = this.props;
    return runoutAge && runoutAge > 0;
  };

  render(): JSX.Element {
    const { incomeGoal } = this.props;

    return (
      <React.Fragment>
        <GlobalFonts />
        <StyledDesktopContainer>
          <SavingsRunOutText>
            {this.areSavingsRunningOut() ? 'Savings may run out at' : 'Savings could last until'}
          </SavingsRunOutText>
          <SavingsRunOutAge>
            Age {this.getSavingsAge()}
            {this.areSavingsRunningOut() ? (
              <SavingsRunOutImage
                src={`data:image/svg+xml;base64,${tokens.AssetIconAlertTriangleFilled}`}
                alt="Icon for off track"
              />
            ) : (
              ''
            )}
          </SavingsRunOutAge>
          <SavingsRunOutText>
            if you start by spending <br /> {formatAmountWithoutDecimals(Math.trunc(incomeGoal))}/year{' '}
            <Link
              linkLabel={
                <SavingsRunOutImage
                  src={`data:image/svg+xml;base64,${tokens.AssetIconInfoIconHeader}`}
                  alt="Savings info icon"
                />
              }
              onClick={this.showSavingsRunOutModal}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showSavingsRunOutModal)}
            />
          </SavingsRunOutText>
        </StyledDesktopContainer>
        <StyledMobileContainer>
          <SavingsRunOutText>
            <div>If you start by spending {formatAmountWithoutDecimals(incomeGoal)}/year,&nbsp;</div>
            <div style={{ display: 'flex' }}>
              {this.areSavingsRunningOut() ? 'savings may run out at' : 'savings could last until'}{' '}
              <Link
                linkLabel={
                  <SavingsRunOutImage
                    src={`data:image/svg+xml;base64,${tokens.AssetIconInfoIconHeader}`}
                    alt="Savings info icon"
                  />
                }
                onClick={this.showSavingsRunOutModal}
                tabIndex={0}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showSavingsRunOutModal)}
              />
            </div>
          </SavingsRunOutText>
          <SavingsRunOutAge>
            {this.areSavingsRunningOut() ? (
              <SavingsRunOutImage
                src={`data:image/svg+xml;base64,${tokens.AssetIconAlertTriangleFilled}`}
                alt="Icon for off track"
              />
            ) : (
              ''
            )}
            Age {this.getSavingsAge()}
          </SavingsRunOutAge>
        </StyledMobileContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { charts } = state;
  return { simulationCurrentWant: charts.simulationCurrentWant, incomeGoal: getIncomeGoal(state) };
};

export default connect(mapStateToProps, { showModal: modalActions.showModal })(SavingsRunOut);
